import { BiFilter } from 'react-icons/bi'

const TableTitle = ({ title }) => {

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '.2rem',
            whiteSpace: "nowrap",
            cursor: "pointer"
        }}
        >
            {title}
            <BiFilter size={20} />
        </div>
    )
}

export default TableTitle